var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"77","height":"77","viewBox":"0 0 77 77","fill":"none"}},[_c('circle',{attrs:{"cx":"38.2297","cy":"38.5","r":"36","fill":"white","stroke":"currentColor","stroke-width":"4","stroke-dasharray":"8 8"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }